import { navigate } from 'gatsby';
import { ssoRedirect } from '../../../helpers/Auth';

const WHITE_LIST = ['/', '/home'];

const useDeepLink = () => {
  if (typeof window === 'undefined') return [null, () => {}];

  const key = 'deep-link';
  const deepLink = window.localStorage.getItem(key);
  const setDeepLink = ({ location }) => {
    const path = location.href.split(location.origin)[1];
    if (!WHITE_LIST.includes(path)) window.localStorage.setItem(key, path);
    ssoRedirect();
  };

  const cleanerDeepLink = () => window.localStorage.removeItem(key);

  const redirectDeepLink = () => {
    if (deepLink) {
      cleanerDeepLink();
      navigate(deepLink);
    } else if (window?.location?.pathname === '/' || '') navigate('/home');
  };

  return { deepLink, setDeepLink, redirectDeepLink, cleanerDeepLink };
};

export default useDeepLink;
